import { defineStore } from "pinia";
import { useLocalStorage } from "@vueuse/core"

export const useConsentStore = defineStore('consent', {
  state: () => {
    return {
      consent: useLocalStorage("download-consent", false) ,
    }
  },
  getters: {
    is_present: (state) => () => state.consent === true,
  },
  actions: {
    set() {
      this.consent = true;
    },
  },
});
